<template>

    <div class="basic-input"
         :class="{'no-label': label.length === 0, disabled}">
        <label :for="name" v-html="label" />
        <textarea v-if="type === 'textarea'"
                  v-mask="mask"
                  v-bind="computedMaxLength"
                  :id="name"
                  class="full-input block"
                  :class="{error: this.status === 'error', success: this.status === 'success', filled: !!value}"
                  :value="this.value"
                  :placeholder="this.placeholder"
                  :cols="cols"
                  :rows="rows"
                  :disabled="disabled"
                  @input="updateValue($event.target.value)"
                  @blur="validateInput()"
                  @change="$emit('change', $event)"
                  @keyup.enter="$emit('confirm')"/>
        <input v-else
               v-mask="mask"
               v-bind="computedMaxLength"
               :type="type"
               :id="name"
               class="full-input block"
               :class="{error: this.status === 'error', success: this.status === 'success', filled: !!value}"
               :value="this.value"
               :placeholder="this.placeholder"
               :step="step"
               :readonly="readonly"
               :min="min"
               :max="max"
               :disabled="disabled"
               :inputmode="inputmode"
               @input="updateValue($event.target.value)"
               @blur="validateInput()"
               @change="$emit('change', $event)"
               @keyup.enter="$emit('confirm')">

        <div class="sub-info" v-if="subInfo.length > 0">
            {{ this.subInfo }}
        </div>

        <i class="fas"
           :class="{'fa-times-circle': this.status === 'error', 'fa-check-circle': this.status === 'success',
            error: this.status === 'error', success: this.status === 'success'}"></i>
        <div class="error-message" v-if="this.status === 'error'">
            {{ this.formatErrorMessages }}
        </div>
    </div>

</template>

<script>

    export default {
        name: 'basic-input',
        props: {
            value: {
                type: [String, Number]
            },
            name: {
                type: String,
                required: true
            },
            label: {
                type: String,
                default: ''
            },
            placeholder: {
                type: String,
                default: ''
            },
            type: {
                type: String,
                default: 'text'
            },
            maxlength: {
                type: Number,
                default: null
            },
            subInfo: {
                type: String,
                default: ''
            },
            initialStatus: {
                type: String,
                default: ''
            },
            initialErrorMessages: {
                type: Array,
                default: () => []
            },
            validate: {
                type: Boolean,
                default: true
            },
            // by default it only checking presence if u want add own validator
            // pass array with validation name and add method according to it
            validators: {
                type: Array,
                default: () => ['presence']
            },
            step: {
                type: String,
                default: '1'
            },
            readonly: {
                type: Boolean,
                default: false
            },
            cols: {
                type: Number,
                default: 20
            },
            rows: {
                type: Number,
                default: 2
            },
            mask: {
                type: String,
                default: ''
            },
            min: {
                type: String,
                default: null
            },
            max: {
                type: String,
                default: null
            },
            disabled: {
                type: Boolean,
                default: false
            },
            inputmode: {
                type: String,
                default: null              
            }
        },
        data: function () {
            return {
                status: this.initialStatus,
                validation_arr: [], // to make order of validation method doesn't matter
                error_messages: this.initialErrorMessages
            }
        },
        computed: {
            formatErrorMessages() {
                return this.error_messages.join(", ")
            },
            computedMaxLength() {
                if (isNaN(this.maxlength)) {
                    return {}
                }

                return {
                    maxlength: this.maxlength
                }
            }
        },
        methods: {
            updateValue (value) {
                this.$emit('input', value)
            },
            emitValid() {
                this.$emit('emitValid', this.status == 'success')
            },
            emitErrors() {
                let errors = {}
                errors[this.name] = this.error_messages
                this.$emit('emitErrors', errors)
            },
            validationSuccess() {
                this.validation_arr.push('success')
                if(this.validation_arr.includes('error')) return
                this.status = 'success'
                this.error_messages = []
            },
            validationError(error_message) {
                this.validation_arr.push('error')
                this.status = 'error'
                this.error_messages.push(error_message)
            },
            validateInput() {
                if(!this.validate) return

                this.error_messages = []
                this.validation_arr = []

                this.$nextTick(() => {
                    if(this.validators.includes('email')) this.validateEmail()
                    if(this.validators.includes('presence')) this.validatePresence()
                    if(this.validators.includes('isNumber')) this.validateIfNumber()
                    if(this.validators.includes('isPassword')) this.validateIfPassword()
                    if(this.validators.includes('isPhoneNumber')) this.validateIfPhoneNumber()
                })

                this.emitErrors()
                this.emitValid()
            },
            //custom validators to call in prev method
            validatePresence() {
                (!!this.value) ? this.validationSuccess() : this.validationError("can't be blank")
            },
            validateEmail() {
                this.validEmail(this.value) ? this.validationSuccess() : this.validationError("wrong email address")
            },
            validateIfNumber() {
                this.isNumeric(this.value) ? this.validationSuccess() : this.validationError("must be number")
            },
            validateIfPhoneNumber() {
              this.validPhoneNumber(this.value) ? this.validationSuccess() : this.validationError("wrong phone number")
            },
            validateIfPassword() {
                (this.value.length >= 8) ? this.validationSuccess() : this.validationError("must be longer than or equal to 8 characters")
            },
            //helper methods to validate
            validEmail(email) {
                let re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                return re.test(email)
            },
            validPhoneNumber(phoneNumber) {
              let cleanedNumber = phoneNumber.replace(/[^\d]/g, '');
              return cleanedNumber.length === 10;
            },
            isNumeric(val) {
                return !isNaN(parseFloat(val)) && isFinite(val)
            }
        },
        watch: {
            initialStatus: function () {
                this.status = this.initialStatus
            },
            initialErrorMessages: function () {
                this.error_messages = this.initialErrorMessages
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import '../assets/stylesheets/variables.scss';

    $error-color: #d02b2b;
    $success-color: #4fbe42;

    .basic-input {
        position: relative;

        input, textarea {
            &.filled {
                border: 1px solid $color-light-black;
                color: $color-light-black;
            }

            &.error {
                border: 1px solid $error-color;
            }

            &.success {
                border: 1px solid $success-color;
            }
        }

        input::placeholder, textarea::placeholder { text-transform: none; }

        &.no-label{
            i {
                top: 16px;
            }
        }

        &.disabled {
            opacity: .5;

            input, textarea {
                cursor: not-allowed !important;
            }
        }

        i {
            position: absolute;
            top: 30px;
            right: 6px;
            font-size: 2rem;

            &.error {
                color: $error-color;
            }

            &.success {
                color: $success-color;
            }
        }

        .error-message{
            color: $error-color;
        }

        .sub-info {
            font-family: OpenSans;
            font-size: 1.4rem;
            line-height: 1.36;
            letter-spacing: 0.34px;
            color: #6c6c6c;

            &.indent {
                margin-left: 22px;
            }
        }
    }

</style>
